import { APP_CONFIG } from '../constants';

/**
 * Obtiene el barrio/ciudad de una branch
 * @param {Object} branch Información del branch
 */
export const getLocality = (branch) => {

    if (branch.state && branch.state === "CAPITAL FEDERAL" && (branch.region && branch.region !== '' || branch.neighborhood && branch.region !== '')) {

        return branch.region || branch.neighborhood;

    } else {

        if (branch.city) {

            return branch.city;

        } else {

            return APP_CONFIG.PAGES.DETAIL.messages.info?.name;

        }
    }
};